import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  costReviewButton: {
    defaultMessage: 'Cost Review',
    description: 'Readonly cost review modal link text',
    id: 'usLXrL',
  },
  genericCostReviewErrorMessageTitle: {
    defaultMessage: 'Cost Review Error',
    description: 'Generic Cost Review Error title for read only cost review',
    id: 'NIG11z',
  },
  genericCostReviewErrorMessage: {
    defaultMessage: 'Unable to process cost review: {errorMessage}',
    description: 'Generic Cost Review Error message for read only cost review',
    id: 'E1MKA5',
  },
  unknownErrorWithoutMessage: {
    defaultMessage: 'An unknown error occurred.',
    description: 'Unknown error without message from server',
    id: 'CId2Ig',
  },
});
